import Box from "@mui/material/Box";
import {
  isStaleCartError,
  clearStaleCartStorage,
  showStaleCartDialog,
  isNoCartError,
  showNoCartDialog,
} from "../../../../utils/staleCartHandler";
import { useAddToCart } from "../hooks/useAddToCart";
import React, { useContext, useEffect, useRef, useState, useMemo, useCallback } from "react";
import vegIcon from "../../../../assets/images/veg-new.png";
import nonVegIcon from "../../../../assets/images/non-veg-icon.svg";
import { useNavigate } from "react-router-dom";
import "./ProductsPage.css";
import Navbar from "layouts/ecommerce/posnavbar/Navbar";
import { UserContext } from "App";
import Modal from "@mui/material/Modal";
import "./LoginPage.css";
import {
  addOpenProductToCart,
  SkipUserFun,
  addCustomer,
  // AddedCustomerData,
  createB2CcustomerApi,
  dataRetriveWhenPageRefresh,
} from "config/Services";
// import { retailUserPayload } from "../../retailuserdetails/retailuserdetails";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Cart } from "./Cart";
import {
  addRestaurantProducts,
  filterCategory,
  getGlobalProductsList,
  applyOrderLevelDiscount,
  restaurantCreateCart,
  aggsFilterCategory,
  filterHotsellingProducts,
  complimentaryCart,
} from "../../../../config/Services";
import { useSelector } from "react-redux";
import { FormControl, InputBase, Stack } from "@mui/material";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { alpha, styled } from "@mui/material/styles";
import { emit } from "react-native-react-bridge/lib/web";
import { getMobilePos } from "./redux/Reducers/paginationReducer";
import useGetDevice from "../hooks/useGetDevice";
import StyledButton from "./components/custom/StyledButton";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import StoreIcon from "@mui/icons-material/Store";
import { addcoupon } from "./redux/Actions/couponActions";

import { useDispatch } from "react-redux";
import { searchTextRes } from "./redux/Actions/paginationActions";
import { useSnackbar } from "../hooks/SnackbarProvider";
import useWeighingItemModal from "../hooks/useWeighingItemModal";
import {
  addManualItemsGTIN,
  addingProductTime,
  changeMultipleBatchesValue,
  changePrevAddedTime,
  eventTrackerTime,
  incrementManuallyAddedProduct,
  setTotalProducts,
} from "./redux/Actions/eventTracker";
import {
  getFullState,
  getManuallyAddedProduct,
  getMultipleBatchValue,
  getTotalProducts,
} from "./redux/Reducers/eventTrackerReducer";
import { removeFromLocalStorage } from "../../../../utils/localStorageHelpers";
import CommonSearchBar from "../../posnavbar/components/commonSearchbar";
import AddonModal from "./components/AddonModal/AddonModal";
import ComboModal from "./components/ComboModal/ComboModal";
import CategoryOptionsPage from "./CategoryOptionsPage";
import DropDownModal from "./components/dropDownModal";
import { useResizablePanels } from "./useResizablePanels";
import CartViewLayoutSection from "./components/CartViewLayoutSection/CartViewLayoutSection";
import AddProductModal from "./components/AddProductModal/AddProductModal";
import CartProductSection from "./components/CartProductSection/CartProductSection";
import MobileCategoryPage from "./MobileCategoryPage";

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-input": {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.mode === "light" ? "#F3F6F9" : "#1A2027",
    border: "1px solid",
    borderColor: theme.palette.mode === "light" ? "#E0E3E7" : "#2D3843",
    fontSize: 16,
    width: "100%",
    padding: "10px 12px",
    transition: theme.transitions.create(["border-color", "background-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
  },
}));

const getProductsResponseMeta = (response) => response?.data?.data?.data || {};
const getProductsFromResponse = (response) => getProductsResponseMeta(response)?.data || [];

const PRODUCTS_PAGE_SIZE = 20;
// Trigger the next-page fetch once the user scrolls within this many products of the end.
const PREFETCH_THRESHOLD_FROM_END = 5;

// Mirrors the key CartProductSection derives per product. Two entries sharing
// this key make React reconcile them as "the same" list item and can bleed
// one card's rendered markup into the other's slot, so any merge of pages
// must be de-duplicated by this same key before it reaches state.
const getProductDedupeKey = (item, retailType) =>
  (retailType === "RESTAURANT"
    ? item?.variants?.[0]?.variantId || item?.id || item?.variants?.[0]?.barcodes?.[0]
    : item?.variant?.variantId || item?.variant?.barcodes?.[0]) ?? null;

const dedupeProducts = (items, retailType) => {
  const seen = new Set();
  const result = [];
  for (const item of items) {
    const key = getProductDedupeKey(item, retailType);
    if (key != null) {
      if (seen.has(key)) continue;
      seen.add(key);
    }
    result?.push(item);
  }
  return result;
};

const normalizeHotSellingProducts = (response) => {
  const rawResults =
    response?.data?.data?.data?.data || response?.data?.data?.data || response?.data?.data || [];

  return (Array.isArray(rawResults) ? rawResults : []).map((item) => {
    const isBundle = item?.isBundle || item?.bundlePrice != null || item?.bundleItems?.length > 0;
    if (isBundle && !item?.isBundle) {
      return {
        ...item,
        isBundle: true,
        variants: item?.variants?.length > 0 ? item.variants : item?.bundleItems || [],
      };
    }
    return item;
  });
};

export const ProductsPage = () => {
  const isMobile = useGetDevice();
  const showSnackbar = useSnackbar();
  const { addItemWithCheck, addItemDirect } = useAddToCart();
  const [customerName, setCustomerName] = useState("");
  const [customerMobileNumber, setCustomerMobileNumber] = useState("");
  const [whatsAppCheck, setWhatsAppCheck] = useState(false);
  const [addModelLoader, setAddModelLoader] = useState(false);
  const [skipModelLoader, setSkipModelLoader] = useState(false);
  const { color, setColor, setCess } = useContext(UserContext);
  const { cartItems, setCartItems } = useContext(UserContext);
  const { cartId: contextCartId, setCartId, setOfferFound } = useContext(UserContext);
  const { selectedTable, setSelectedTable } = useContext(UserContext);
  let cartId = localStorage.getItem("CartId");

  const { subTotal, setSubTotal } = useContext(UserContext);
  const { total, setTotal, saleMode, setTotalValue, setSaleMode, searchActive, setSearchActive } =
    useContext(UserContext);
  const { cgst, setCgst } = useContext(UserContext);
  const { sgst, setSgst } = useContext(UserContext);
  const { totalTaxes, setTotalTaxes } = useContext(UserContext);
  const { highlightMrp, setHighlightMrp, setHighlightedCartProductId } = useContext(UserContext);
  const { particularCategoryItems, setparticularCategoryItems } = useContext(UserContext);
  const { categoryName, setCategoryName } = useContext(UserContext);
  const { setCartTotalQty, firstTimeSearchRef } = useContext(UserContext);
  const { setCouponApplied: setContextCouponApplied } = useContext(UserContext);
  const [
    addItemThroughParticularCategoryItemLoader,
    setAddItemThroughParticularCategoryItemLoader,
  ] = useState(null);
  const { findWeighingItem, renderWeighingModal } = useWeighingItemModal({
    setAddItemThroughParticularCategoryItemLoader,
  });
  // const [data, setData] = useState([]);
  const inputRef = useRef(null);
  const firstElementRef = useRef(null);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [openCustomerDetailTrigger, setOpenCustomerDetailTrigger] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [addProductModal, setAddProductModal] = useState(false);
  const [addProductLoader, setAddProductLoader] = useState(false);
  const [discountResetSignal, setDiscountResetSignal] = useState(0);
  const appConfig = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("appConfig")) || {};
    } catch {
      return {};
    }
  }, []);
  const creationOfMenuEnabled = appConfig?.all?.CREATION_OF_MENU?.flag === true;
  const [selectedMrp, setSelectedMrp] = useState("");
  const [SelectedSellingPrice, setSelectedSellingPrice] = useState("");
  const [selectedGtin, setSelectedGtin] = useState("");
  const [selectedProduct, setSelectedProduct] = useState("");
  const [noresults, setNoresults] = useState(true);
  const [pagination, setPagination] = useState({ page: 1, pageSize: 10 });
  const [mrps, setMrps] = useState([]);
  const [responseCartTimes, setResponseCartTimes] = useState(() => {
    const item = localStorage.getItem("responseCartTimes");
    return item ? JSON.parse(item) : [];
  });

  const [addItemResponseTime, setAddItemResponseTime] = useState(() => {
    const item = localStorage.getItem("addItemResponseTime");
    return item ? JSON.parse(item) : [];
  });

  const [customerMobile, setCustomerMobile] = useState(() => {
    const item = localStorage.getItem("customer_details");
    try {
      return item ? JSON.parse(item)?.mobileNumber || "" : "";
    } catch (error) {
      console.error("Error parsing customer_details from localStorage", error);
      return "";
    }
  });
  const searchLoader = useSelector((state) => state.pagination.loading);
  const isMobilePos = useSelector(getMobilePos);
  const handleOpen = () => setOpen(true);
  const appDrawer = useSelector((state) => state.pagination.appDrawer);
  const orgId = localStorage.getItem("orgId");
  let retailUserLocalStorageData = JSON.parse(localStorage.getItem("retailUserDetails"));
  const locId = localStorage.getItem("locId");
  const licenseId = localStorage.getItem("licenseId");
  const sessionId = localStorage.getItem("sessionId");
  const [couponApplied, setCouponApplied] = useState("0");
  const [appliedState, setAppliedState] = useState(false);
  const [offerData, setOfferData] = useState(null);
  const dispatch = useDispatch();
  const [isBatchSelected, setIsBatchSelected] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [brandName, setBrandName] = useState("");
  const [packagingType, setPackagingType] = useState("");
  const [variantName, setVariantName] = useState("");
  const [vendorId, setVendorId] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [availableUnits, setAvailableUnits] = useState("");
  const [sellingUnit, setSellingUnit] = useState("");
  const [categoryModalOpen, setCategoryModalOpen] = useState(false);
  const [addOnModalOpen, setAddOnModalOpen] = useState(false);
  const [addOnProductList, setAddOnProductList] = useState([]);
  const [variantProductList, setVariantProductList] = useState([]);
  const [selectedProductForCart, setSelectedProductForCart] = useState(null);
  const [comboModalOpen, setComboModalOpen] = useState(false);
  const [comboModalProduct, setComboModalProduct] = useState(null);
  const [comboModalPrice, setComboModalPrice] = useState(0);
  const [comboModalIndex, setComboModalIndex] = useState(null);
  const [activeFilter, setActiveFilter] = useState("ALL");
  const [currentFoodType, setCurrentFoodType] = useState("");

  // two layouts - 1.cardViewLayout 2.rowViewLayout
  const [layoutType, setLayoutType] = useState(
    () => localStorage.getItem("particularCategoryLayoutType") || "cardViewLayout"
  );
  const [goToMobileCategory, setGoToMobileCategory] = useState(false);
  const [openProductList, setOpenProductList] = useState(false);
  const gridRef = useRef(null);
  const productListContainerRef = useRef(null);
  const setProductListContainerRefs = useCallback((node) => {
    firstElementRef.current = node;
    productListContainerRef.current = node;
  }, []);
  // gridRef (not productListContainerRef, which is just an inner non-scrolling
  // wrapper) is the element that actually scrolls — see .particularCategoryEachItemGridContainerCFSCartPage.
  const scrollProductListToTop = useCallback(() => {
    gridRef.current?.scrollTo({ top: 0 });
  }, []);
  const handleLayoutTypeChange = useCallback(
    (type) => {
      if (type === layoutType) return;

      scrollProductListToTop();
      localStorage.setItem("particularCategoryLayoutType", type);
      setLayoutType(type);
    },
    [layoutType, scrollProductListToTop]
  );

  // ── Keyboard navigation state ──────────────────────────────────────────────
  const [focusedProductIndex, setFocusedProductIndex] = useState(-1);

  // Refs for keyboard handler — kept in sync on every render so the handler
  // never reads stale closure values.
  const addOnModalOpenRef = useRef(false);
  const categoryModalOpenRef = useRef(false);
  const filterSelectionRef = useRef(null);
  const focusedProductIndexRef = useRef(-1);
  const particularCategoryItemsRef = useRef([]);
  const handleProductActionRef = useRef(null);

  const { categoryPanelWidth, cartPanelWidthState, startResizingCategory, startResizingCart } =
    useResizablePanels();

  const retailType = localStorage.getItem("retailType");
  const branchSubType = localStorage.getItem("branchSubType");
  const licenseName = localStorage.getItem("licenseName");

  const { searchText, setSearchText, page, setPage, hasMore, setHasMore } = useContext(UserContext);
  const standardProductsEnabled =
    currentFoodType !== "HOT_SELLING" && !searchActive && !(searchText || "").trim();
  const hotSellingEnabled =
    retailType === "RESTAURANT" && currentFoodType === "HOT_SELLING" && !searchActive;

  const [productsData, setProductsData] = useState([]);
  const [productsLoading, setProductsLoading] = useState(false);
  const [productsFetching, setProductsFetching] = useState(false);
  const [productsError, setProductsError] = useState(null);

  const [hotSellingData, setHotSellingData] = useState([]);
  const [hotSellingLoading, setHotSellingLoading] = useState(false);
  const [hotSellingFetching, setHotSellingFetching] = useState(false);
  const [hotSellingError, setHotSellingError] = useState(null);

  // categoryName lives in shared UserContext, so it survives this page unmounting
  // and remounting on navigation. The mount-reset effect further below clears it,
  // but that clear only lands on the render after this one — until then, treat the
  // stale value as empty so we don't fire an extra request with the old category.
  const categoryResetPendingRef = useRef(true);
  const effectiveCategoryName = categoryResetPendingRef.current ? "" : categoryName;
  const prevSaleModeRef = useRef(saleMode);

  // ── Infinite-scroll bookkeeping ──────────────────────────────────────────────
  // Kept as refs (not state) since they're read/written inside scroll-driven
  // callbacks and must never trigger a re-render on their own.
  const productsPageRef = useRef(1);
  const productsHasMoreRef = useRef(true);
  const productsFetchingMoreRef = useRef(false);
  const hotSellingPageRef = useRef(1);
  const hotSellingHasMoreRef = useRef(true);
  const hotSellingFetchingMoreRef = useRef(false);
  // Bumped every time the request context (category/filter/saleMode/...) changes.
  // Any in-flight page-1 or "load more" response whose epoch no longer matches
  // belongs to a stale context and must be discarded — otherwise a prefetch that
  // resolves after switching saleMode/category can append the wrong products
  // (and wrong-typed cards/images) onto the new, unrelated list.
  const productsEpochRef = useRef(0);
  const hotSellingEpochRef = useRef(0);
  // Search results (particularCategoryItems) are owned/replaced by CommonSearchBar's
  // own debounced page-1 fetch; page/hasMore for that list live in UserContext
  // (already populated by that fetch) since nothing previously consumed them.
  // We only own the "load more" continuation and its staleness guard here.
  const searchFetchingMoreRef = useRef(false);
  const searchEpochRef = useRef(0);

  // Any keystroke or search-active toggle invalidates whatever search "load more"
  // was in flight, the same way productsEpochRef/hotSellingEpochRef do above.
  // It also means a fresh (page-1) result set is about to replace what's shown —
  // owned by CommonSearchBar, not us — so reset scroll now rather than leaving
  // it clamped to wherever the previous, possibly-longer list left off.
  useEffect(() => {
    searchEpochRef.current += 1;
    scrollProductListToTop();
  }, [searchText, searchActive, scrollProductListToTop]);

  const buildStandardProductsPayload = useCallback(
    (pageNum) => {
      const isCombosFilter = currentFoodType === "COMBOS";
      return {
        page: pageNum,
        ...(retailType === "RESTAURANT" &&
          currentFoodType &&
          !isCombosFilter && { foodType: [currentFoodType] }),
        ...(retailType === "RESTAURANT" && isCombosFilter && { showBundles: true }),
        ...(retailType === "RESTAURANT" && !isCombosFilter && { bundleIncluded: true }),
        pageSize: PRODUCTS_PAGE_SIZE,
        ...(effectiveCategoryName && {
          appCategories: { categoryLevel1: [effectiveCategoryName] },
        }),
        query: "",
        storeLocations: [locId],
        storeIds: [orgId],
        ...(retailType !== "RESTAURANT" && { flattenResponse: true }),
        ...(retailType === "RESTAURANT" && { productTypes: ["MENU"] }),
        ...(retailType === "RESTAURANT" && branchSubType === "QSR"
          ? saleMode === "QSR_DINE_IN"
            ? { salesChannels: ["DINE_IN"] }
            : { salesChannels: [saleMode] }
          : { salesChannels: [saleMode] }),
        ...(retailType === "RESTAURANT" && { stockStatuses: ["IN_STOCK"] }),
      };
    },
    [currentFoodType, retailType, branchSubType, saleMode, effectiveCategoryName, locId]
  );

  //Fetching the standard (non hot-selling) product list for the current category/filters
  useEffect(() => {
    if (!standardProductsEnabled) return;
    productsEpochRef.current += 1;
    const epoch = productsEpochRef.current;
    setProductsLoading(true);
    setProductsFetching(true);
    // Reset paging synchronously (not just on success) so that any load-more
    // call sneaking in before this resolves can't use a stale page/hasMore
    // from a previous saleMode/category/filter and can't run concurrently.
    productsPageRef.current = 1;
    productsHasMoreRef.current = false;
    productsFetchingMoreRef.current = true;

    getGlobalProductsList(buildStandardProductsPayload(1))
      .then((response) => {
        if (productsEpochRef.current !== epoch) return; // stale — context changed since this was fired
        const fetchedProducts = getProductsFromResponse(response);
        setProductsData(dedupeProducts(fetchedProducts, retailType));
        setparticularCategoryItems(dedupeProducts(fetchedProducts, retailType));
        // A fresh page-1 list must be viewed from the top — otherwise the
        // container stays scrolled to wherever the previous (taller) list
        // left off, the browser clamps that to the new list's bottom, and
        // the prefetch observer — sitting right there — fires repeatedly to
        // "catch up" through page 2, 3, ... before settling.
        scrollProductListToTop();
        setPage(1);
        setNoresults(fetchedProducts.length === 0);
        firstTimeSearchRef.current = false;
        setProductsError(null);
        productsPageRef.current = 1;
        productsHasMoreRef.current = fetchedProducts.length >= PRODUCTS_PAGE_SIZE;
      })
      .catch((error) => {
        if (productsEpochRef.current !== epoch) return;
        setProductsError(error);
        productsHasMoreRef.current = false;
      })
      .finally(() => {
        // Only the latest (matching) request may clear the in-flight guard —
        // otherwise a stale response settling first would prematurely unblock
        // loadMore while the real page-1 request for the new context is still
        // pending, letting it fire with a stale page/hasMore in the meantime.
        if (productsEpochRef.current !== epoch) return;
        productsFetchingMoreRef.current = false;
        prevSaleModeRef.current = saleMode;
        setProductsLoading(false);
        setProductsFetching(false);
      });
  }, [standardProductsEnabled, buildStandardProductsPayload, retailType, scrollProductListToTop]);

  //Fetching hot-selling products (restaurant only)
  useEffect(() => {
    if (!hotSellingEnabled) return;
    hotSellingEpochRef.current += 1;
    const epoch = hotSellingEpochRef.current;
    setHotSellingLoading(true);
    setHotSellingFetching(true);
    hotSellingPageRef.current = 1;
    hotSellingHasMoreRef.current = false;
    hotSellingFetchingMoreRef.current = true;

    filterHotsellingProducts({ page: 1, pageSize: PRODUCTS_PAGE_SIZE, orgId, locationId: locId })
      .then((response) => {
        if (hotSellingEpochRef.current !== epoch) return;
        const fetchedHotSelling = normalizeHotSellingProducts(response);
        setHotSellingData(dedupeProducts(fetchedHotSelling, retailType));
        setparticularCategoryItems(dedupeProducts(fetchedHotSelling, retailType));
        scrollProductListToTop();
        setPage(1);
        setNoresults(fetchedHotSelling.length === 0);
        setHotSellingError(null);
        hotSellingPageRef.current = 1;
        hotSellingHasMoreRef.current = fetchedHotSelling.length >= PRODUCTS_PAGE_SIZE;
      })
      .catch((error) => {
        if (hotSellingEpochRef.current !== epoch) return;
        setHotSellingError(error);
        hotSellingHasMoreRef.current = false;
      })
      .finally(() => {
        if (hotSellingEpochRef.current !== epoch) return;
        hotSellingFetchingMoreRef.current = false;
        prevSaleModeRef.current = saleMode;
        setHotSellingLoading(false);
        setHotSellingFetching(false);
      });
  }, [hotSellingEnabled, orgId, locId, saleMode, retailType, scrollProductListToTop]);

  // ── Load the next page and append it to whichever list is currently active ──
  const loadMoreProducts = useCallback(() => {
    if (searchActive) {
      if (searchFetchingMoreRef.current || !hasMore) return;
      searchFetchingMoreRef.current = true;
      const epoch = searchEpochRef.current;
      const nextPage = page + 1;
      const query = searchText;
      const searchPayload = {
        page: nextPage,
        pageSize: PRODUCTS_PAGE_SIZE,
        query,
        storeLocations: [locId],
        storeIds: [orgId],
        ...(retailType !== "RESTAURANT" && { flattenResponse: true }),
        ...(retailType === "RESTAURANT" && { productTypes: ["MENU"] }),
        ...(retailType === "RESTAURANT" && { salesChannels: [saleMode] }),
        ...(retailType === "RESTAURANT" && { stockStatuses: ["IN_STOCK"] }),
        ...(retailType === "RESTAURANT" && { bundleIncluded: true }),
      };
      getGlobalProductsList(searchPayload)
        .then((response) => {
          if (searchEpochRef.current !== epoch) return; // search text/mode changed — discard
          const meta = response?.data?.data?.data;
          const fetched = meta?.data || [];
          setHasMore(meta?.currentPage < meta?.totalPages);
          if (fetched.length === 0) return;
          setPage(nextPage);
          setparticularCategoryItems((prev) => dedupeProducts([...prev, ...fetched], retailType));
        })
        .catch(() => {
          if (searchEpochRef.current !== epoch) return;
          setHasMore(false);
        })
        .finally(() => {
          if (searchEpochRef.current === epoch) searchFetchingMoreRef.current = false;
        });
      return;
    }

    if (currentFoodType === "HOT_SELLING") {
      if (!hotSellingEnabled) return;
      if (hotSellingFetchingMoreRef.current || !hotSellingHasMoreRef.current) return;
      hotSellingFetchingMoreRef.current = true;
      const epoch = hotSellingEpochRef.current;
      const nextPage = hotSellingPageRef.current + 1;
      filterHotsellingProducts({
        page: nextPage,
        pageSize: PRODUCTS_PAGE_SIZE,
        orgId,
        locationId: locId,
      })
        .then((response) => {
          if (hotSellingEpochRef.current !== epoch) return; // context changed — discard
          const fetched = normalizeHotSellingProducts(response);
          hotSellingHasMoreRef.current = fetched.length >= PRODUCTS_PAGE_SIZE;
          if (fetched.length === 0) return;
          hotSellingPageRef.current = nextPage;
          setHotSellingData((prev) => dedupeProducts([...prev, ...fetched], retailType));
        })
        .catch(() => {
          if (hotSellingEpochRef.current !== epoch) return;
          hotSellingHasMoreRef.current = false;
        })
        .finally(() => {
          // Only clear the guard if we're still the latest request — a stale
          // response settling first must not unblock a newer, still-pending
          // page-1 load (see the matching comment in the fetch effect above).
          if (hotSellingEpochRef.current === epoch) hotSellingFetchingMoreRef.current = false;
        });
      return;
    }

    if (!standardProductsEnabled) return;
    if (productsFetchingMoreRef.current || !productsHasMoreRef.current) return;
    productsFetchingMoreRef.current = true;
    const epoch = productsEpochRef.current;
    const nextPage = productsPageRef.current + 1;
    getGlobalProductsList(buildStandardProductsPayload(nextPage))
      .then((response) => {
        if (productsEpochRef.current !== epoch) return; // context changed — discard
        const fetched = getProductsFromResponse(response);
        productsHasMoreRef.current = fetched.length >= PRODUCTS_PAGE_SIZE;
        if (fetched.length === 0) return;
        productsPageRef.current = nextPage;
        setProductsData((prev) => dedupeProducts([...prev, ...fetched], retailType));
      })
      .catch(() => {
        if (productsEpochRef.current !== epoch) return;
        productsHasMoreRef.current = false;
      })
      .finally(() => {
        if (productsEpochRef.current === epoch) productsFetchingMoreRef.current = false;
      });
  }, [
    searchActive,
    hasMore,
    page,
    searchText,
    saleMode,
    currentFoodType,
    hotSellingEnabled,
    standardProductsEnabled,
    buildStandardProductsPayload,
    orgId,
    locId,
    retailType,
    setHasMore,
    setPage,
    setparticularCategoryItems,
  ]);

  // ── IntersectionObserver: prefetch the next page once the product ──────────
  // PREFETCH_THRESHOLD_FROM_END-th-from-last product scrolls into view. Works
  // the same way for all three layouts since they share this render loop.
  const observerTargetNodeRef = useRef(null);
  const setObserverTargetRef = useCallback((node) => {
    observerTargetNodeRef.current = node;
  }, []);
  const observerTargetIndex = Math.max(
    particularCategoryItems.length - PREFETCH_THRESHOLD_FROM_END,
    0
  );

  useEffect(() => {
    if (isMobile) return;
    const root = gridRef.current;
    const target = observerTargetNodeRef.current;
    if (!root || !target) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) loadMoreProducts();
      },
      { root, rootMargin: "200px", threshold: 0 }
    );
    observer.observe(target);
    return () => observer.disconnect();
  }, [isMobile, particularCategoryItems, layoutType, loadMoreProducts]);

  const isSaleModeChanging = prevSaleModeRef.current !== saleMode;
  const loader =
    isSaleModeChanging || (currentFoodType === "HOT_SELLING" ? hotSellingLoading : productsLoading);
  const productsRefreshing =
    currentFoodType === "HOT_SELLING"
      ? hotSellingFetching && !hotSellingLoading
      : productsFetching && !productsLoading;

  // useEffect for get the retail user details
  //order metrics states
  const multipleBatchCheck = useSelector(getMultipleBatchValue);

  const [mannuallyEnteredProduct, setMannuallyEnteredProduct] = useState(
    useSelector(getManuallyAddedProduct) || 0
  );
  const totalProducts = useSelector(getTotalProducts);
  const orderMetricDataFullState = useSelector(getFullState);

  //Retriving data on page refresh
  useEffect(() => {
    if (localStorage.getItem("CartId")) {
      // If cartId is already in context the cart was just created (e.g. from
      // table layout dine-in flow) — all data is already in context, skip fetch.
      if (contextCartId) return;

      let cartId = localStorage.getItem("CartId");
      dataRetriveWhenPageRefresh(cartId)
        .then((res) => {
          // Cart is already closed (200 response with es:2 / statusCode:10002)
          if (res?.data?.data?.es === 2 || res?.data?.data?.statusCode === 10002) {
            removeFromLocalStorage("CartId");
            setOpenCustomerDetailTrigger((prev) => prev + 1);
            return;
          }

          //Display selected table upon refresh
          setSelectedTable((prev) => ({
            ...prev,
            tableNoForDisplay: res?.data?.data?.data?.tableNumber,
          }));
          setCartId(res?.data?.data?.data?.cartId);
          setCartItems(res?.data?.data?.data?.cartProducts);
          const subOrderType = res?.data?.data?.data?.subOrderType;
          if (retailType === "RESTAURANT") {
            if (!subOrderType) {
              // Cart has no subOrderType (e.g. after a split payment refresh) — create a fresh cart
              setSaleMode("DINE_IN");
              const newCartPayload = {
                cartId: null,
                userName: retailUserLocalStorageData?.name || null,
                userId: retailUserLocalStorageData?.uidx || null,
                tableNumber: "1",
                tableId: "1",
                mobileNo: null,
                enableWhatsapp: true,
                createdBy: retailUserLocalStorageData?.uidx,
                createdByName: retailUserLocalStorageData?.firstName,
                updatedBy: retailUserLocalStorageData?.uidx,
                updatedByName: retailUserLocalStorageData?.firstName,
                locationId: locId || "",
                sourceId: orgId || "",
                licenseId: licenseId || null,
                terminalName: licenseName || null,
                orderType: "RESTAURANT_ORDER",
                subOrderType: "DINE_IN",
                sourceLocationId: locId || "",
                sourceType: "RETAIL",
                channel: "POS",
                loggedInUser: retailUserLocalStorageData?.uidx,
                sourceApp: "PALLET_POS",
                destinationId: orgId || "",
                destinationLocationId: locId || "",
                destinationType: "RETAIL",
                sessionId: sessionId || null,
              };
              restaurantCreateCart(newCartPayload)
                .then((createRes) => {
                  const newCart = createRes?.data?.data?.data;
                  if (newCart?.cartId) {
                    setCartId(newCart.cartId);
                    localStorage.setItem("CartId", newCart.cartId);
                    setCartItems(newCart.cartProducts || []);
                  }
                })
                .catch(() => {});
            } else if (subOrderType === "QSR_DINE_IN") {
              setSaleMode("DINE_IN");
            } else {
              setSaleMode(subOrderType);
            }
          } else {
            setSaleMode(subOrderType || "DINE_IN");
          }
          setCgst(res?.data?.data?.data?.billing?.cgst);
          setSgst(res?.data?.data?.data?.billing?.sgst);
          setCess(res?.data?.data?.data?.billing?.totalCessAmount);
          setSubTotal(res?.data?.data?.data?.billing?.subtotal);
          setTotal(res?.data?.data?.data?.billing?.totalCartValue);
          setTotalValue(res?.data?.data?.data?.billing?.totalValue);
          setTotalTaxes(res?.data?.data?.data?.billing?.tax);
          setOfferFound(res?.data?.data?.data?.offerProductFound);
          setCouponApplied(res?.data?.data?.data?.billing?.appliedCoupon);
          if (Number(res?.data?.data?.data?.billing?.appliedCoupon) > 0) {
            // dispatch(
            //   addcoupon({
            //     couponValue: res?.data?.data?.data?.billing?.appliedCoupon,
            //   })
            // );
            dispatch(addcoupon(res?.data?.data?.data?.cartCoupon));
          }
        })
        .catch((err) => {
          const errMsg = err?.response?.data?.message || err?.message || "";
          if (isStaleCartError(errMsg)) {
            clearStaleCartStorage();
            showStaleCartDialog();
          } else {
            showSnackbar(errMsg, "error");
          }
        });
    }
  }, []);

  //Payload for non-restraunts retail type
  const retailPayload = {
    userName: null,
    userId: null,
    mobileNo: null,
    createdBy: retailUserLocalStorageData?.firstName,
    locationId: locId || "",
    sourceId: orgId || "",
    loggedInUser: retailUserLocalStorageData?.uidx,
    sourceLocationId: locId || "",
    sourceType: "RETAIL",
    sourceApp: saleMode === "delivery" ? "PALLET_RETAIL" : "PALLET_POS",
    destinationId: orgId || "",
    destinationLocationId: locId || "",
    destinationType: "RETAIL",
    comments: null,
    sessionId: sessionId || null,
    orderType: saleMode === "delivery" ? "B2C_ORDER" : "POS_ORDER",
    subOrderType: isMobile ? "MPOS_ORDER" : "POS_ORDER",
    licenseId: licenseId || null,
    hoId: null,
    channel: "POS",
  };

  const handleClose = () => {
    setSkipModelLoader(true);
    SkipUserFun(retailPayload)
      .then((res) => {
        const customer_details = {
          name: null,
          mobileNumber: null,
          uidx: null,
          whatsapp: false,
        };
        if (!cartItems.length) {
          const currentTime = new Date().getTime();
          dispatch(eventTrackerTime({ startTime: currentTime, startTimeAdded: true }));
          dispatch(changePrevAddedTime(currentTime));
          const orderMetricData = {
            ...orderMetricDataFullState,
            startTime: currentTime,
            prevAddedProductTime: currentTime,
            startTimeAdded: true,
          };
          localStorage.setItem("orderMetricData", JSON.stringify(orderMetricData));
        }
        setCartId(res.data.data.cartId);
        setCartItems(res.data.data.cartProducts);
        setCgst(res.data.data.billing.cgst);
        setSgst(res.data.data.billing.sgst);
        setCess(res.data.data.billing.totalCessAmount);
        setSubTotal(res?.data?.data?.billing?.subtotal);
        setTotal(res.data.data.billing.totalCartValue);
        setTotalTaxes(res?.data?.data?.billing?.tax);
        setTotalValue(res?.data?.data?.billing?.totalValue);
        setOpen(false);
        setSkipModelLoader(false);
        setCustomerMobile("");
        localStorage.setItem("CartId", res.data.data.cartId);
        localStorage.setItem("customer_details", JSON.stringify(customer_details));
        isMobilePos &&
          emit({
            type: "localData",
            data: {
              CartId: res.data.data.cartId,
              customer_details: customer_details,
            },
          });
      })
      .catch((err) => {});
  };

  // add customer Functionality implemented
  const addCustomerFun = () => {
    let addCustomerPayload = {
      mobile: customerMobileNumber,
      firstName: customerName,
    };
    if (customerMobileNumber?.length !== 10) {
      showSnackbar("Please enter valid credential", "error");
    } else {
      addCustomer(addCustomerPayload).then((res) => {
        setAddModelLoader(true);
        let customerUidxData = {
          uidx: res?.data?.data?.uidx,
          phoneNumber: customerMobileNumber,
          name: customerName,
          organizationId: orgId,
          createdBy: retailUserLocalStorageData.uidx,
          locationId: locId,
          platform: "POS"
        };
        /*
        AddedCustomerData(customerUidxData)
        */
        createB2CcustomerApi(customerUidxData)
          .then((resp) => {
            retailPayload.userName = customerName;
            retailPayload.mobileNo = customerMobileNumber;
            retailPayload.userId = customerUidxData.uidx;
            SkipUserFun(retailPayload)
              .then((response) => {
                const customer_details = {
                  name: customerName,
                  mobileNumber: customerMobileNumber,
                  uidx: res.data.data.uidx,
                  whatsapp: whatsAppCheck,
                };
                if (!cartItems.length) {
                  const currentTime = new Date().getTime();
                  dispatch(eventTrackerTime({ startTime: currentTime, startTimeAdded: true }));
                  dispatch(changePrevAddedTime(currentTime));
                  const orderMetricData = {
                    ...orderMetricDataFullState,
                    startTime: currentTime,
                    prevAddedProductTime: currentTime,
                    startTimeAdded: true,
                  };
                  localStorage.setItem("orderMetricData", JSON.stringify(orderMetricData));
                }
                setCartId(response.data.data.cartId);
                setCartItems(response.data.data.cartProducts);
                setCgst(response.data.data.billing.cgst);
                setSgst(response.data.data.billing.sgst);
                setCess(response.data.data.billing.totalCessAmount);
                setSubTotal(response?.data?.data?.billing?.subtotal);
                setTotal(response.data.data.billing.totalCartValue);
                setTotalTaxes(response?.data?.data?.billing?.tax);
                setTotalValue(response?.data?.data?.billing?.totalValue);
                setOpen(false);
                retailPayload.userName = null;
                retailPayload.mobileNo = null;
                retailPayload.userId = null;
                localStorage.setItem("CartId", response.data.data.cartId);
                localStorage.setItem("customer_details", JSON.stringify(customer_details));
                isMobilePos &&
                  emit({
                    type: "localData",
                    data: {
                      CartId: response.data.data.cartId,
                      customer_details: customer_details,
                    },
                  });
                setCustomerName("");
                setCustomerMobileNumber("");
                setAddModelLoader(false);
              })
              .catch((err) => {
                showSnackbar(err.response.data.message, "error");
                setAddModelLoader(false);
              });
          })
          .catch((err) => {
            showSnackbar(err.response.data.message, "error");
          });
      });
    }
  };

  //Fetching Categories on the opening of the page
  // useEffect(() => {
  //   const payload = {
  //     page: 1,
  //     pageSize: 50,
  //     sourceId: [orgId],
  //     sourceLocationId: [locId],
  //     type: ["APP"],
  //     sortByUpdatedDate: "DESCENDING",
  //   };
  //   //API to filter category
  //   filterCategory(payload)
  //     .then((response) => {
  //       setData(response?.data?.data?.results);
  //     })
  //     .catch((err) => {});
  //   firstElementRef?.current?.focus();
  // }, []);

  const payload = useMemo(
    () => ({
      page: 1,
      pageSize: 50,
      ...(retailType === "RESTAURANT" ? { storeIds: [orgId] } : { sourceId: [orgId] }),
      ...(retailType === "RESTAURANT" ? { storeLocations: [locId] } : { sourceLocationId: [locId] }),
      ...(retailType !== "RESTAURANT" && { type: ["APP"] }),
      ...(retailType === "RESTAURANT"
        ? { sortByUpdatedAt: "DESC" }
        : { sortByUpdatedDate: "DESCENDING" }),
      ...(retailType === "RESTAURANT" && { productTypes: ["MENU"] }),
      ...(retailType === "RESTAURANT" && branchSubType === "QSR"
        ? saleMode === "QSR_DINE_IN"
          ? { salesChannels: ["DINE_IN"] }
          : { salesChannels: [saleMode] }
        : { salesChannels: [saleMode] }),
    }),
    [orgId, locId, saleMode]
  );

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isCurrent = true;
    const fetchFunction = retailType === "RESTAURANT" ? aggsFilterCategory : filterCategory;
    setLoading(true);
    fetchFunction(payload)
      .then((result) => {
        if (!isCurrent) return;
        const resolved =
          retailType === "RESTAURANT" ? result?.data?.data?.data : result?.data?.data?.results;
        setData(resolved);
      })
      .catch((error) => {
        if (!isCurrent) return;
        showSnackbar(error?.message || error?.data?.message || error?.data?.data?.message, "error");
      })
      .finally(() => {
        if (isCurrent) setLoading(false);
      });
    return () => {
      isCurrent = false;
    };
  }, [retailType, JSON.stringify(payload)]);

  const [sellingprice, setSellingprice] = useState("");
  const { animationBox, setanimationBox } = useContext(UserContext);
  const { gtinItem, setItemgtin } = useContext(UserContext);

  // Adds a product to the active cart. Handles both retail types:
  //  - non-RESTAURANT: always calls the gtin-based add-product API (qty is not used).
  //  - RESTAURANT: always calls addRestaurantProducts with the requested qty
  //    (defaults to 1 for a quick add, e.g. tapping a product card), even when the
  //    variant is already in the cart — the add API owns merging/incrementing.
  const increseItemQuantityTroughParticularCategory = (
    gtin,
    name,
    index,
    packaging_type,
    sellingUnit,
    variantId,
    sellingPrice,
    addOn,
    id,
    isBundle,
    productId,
    comments,
    qty = null,
    isComplimentary = false
  ) => {
    const initialTime = new Date().getTime();
    setAddItemThroughParticularCategoryItemLoader(index);

    //Transforming the Addon array for sutaible keys according to the API's payload requirement
    const transformedArray = addOn?.map((item) => ({
      variantId: item?.variantId,
      itemName: item?.title,
      sellingPrice: item?.additionalPrice ?? 0,
      igst: Number(item?.gst) ?? 0,
      sellingUnit: item?.unitOfMeasure ?? "PCS",
      specification: item?.specification,
      quantity: item?.qty,
    }));

    //Payload to use when retail type is not RESTAURANT

    let payload = {
      gtin: gtin,
      cartId: cartId,
      locationId: locId,
      orgId: orgId,
    };
    //Payload to use when retail type is RESTAURANT
    let restaurantPayload = {
      ...(isBundle ? { variantId: productId } : { variantId: variantId || "NA" }),
      cartId: cartId,
      locationId: locId,
      orgId: orgId,
      qty: qty != null && Number(qty) >= 1 ? Number(qty) : 1,
      addonProducts: transformedArray,
      ...(comments ? { comments } : {}),
    };
    const start = new Date().getTime();
    //checking if the selected item is weighing item
    if (findWeighingItem(gtin, name, packaging_type, sellingUnit, variantId)) {
      setAddItemThroughParticularCategoryItemLoader(null);
      return;
    }
    // Applies a cart response (from add or qty update) to the UI state
    const applyCartState = (data, products) => {
      setCartItems(products);
      if (products?.[0]?.cartProductId) {
        setHighlightedCartProductId(products[0].cartProductId);
        setTimeout(() => setHighlightedCartProductId(null), 2000);
      }
      setOfferFound(data?.offerProductFound);
      setCgst(data?.billing?.cgst);
      setSgst(data?.billing?.sgst);
      setCess(data?.billing?.totalCessAmount);
      setTotal(data?.billing?.totalCartValue);
      setTotalValue(data?.billing?.totalValue);
      setSubTotal(data?.billing?.subtotal);
      setTotalTaxes(data?.billing?.tax);
      setCouponApplied(data?.billing?.appliedCoupon);
    };

    //Checking whether the retail type is RESTAURANT or not, then calling different APIs accordingly.
    if (retailType === "RESTAURANT") {
      //API to add products on cart when the retailtype is RESTAURANT
      addRestaurantProducts(restaurantPayload).then((res) => {
        //If there is an error show the error using snackbar and return
        if (
          res?.data?.status === "ERROR" ||
          res?.data?.status === "error" ||
          res?.data?.data?.es > 0
        ) {
          showSnackbar(res?.data?.message || res?.data?.data?.message, "error");
          setAddItemThroughParticularCategoryItemLoader(null);
          return;
        }
        if (isProfilerOn) {
          const end = new Date().getTime();
          const timeTaken = end - start;

          const updatedResponseTimes = [
            ...responseInventoryTimes,
            { time: end, responseTime: timeTaken },
          ];
          localStorage.setItem("responseInventoryTimes", JSON.stringify(updatedResponseTimes));
          setResponseInventoryTimes(updatedResponseTimes);
        }
        if (res?.data?.data?.data?.length > 1 && res?.data?.data?.es === 0) {
          dispatch(changeMultipleBatchesValue(true));
          const backupData = {
            ...orderMetricDataFullState,
            isMultipleBatch: true,
          };
          localStorage.setItem("orderMetricData", JSON.stringify(backupData));
          //Stroring response into varaible dataArr, and stroing the values into the states using this dataArr
          const dataArr = res?.data?.data?.data.map((item) => {
            return {
              mrp: item?.mrp,
              sellingPrice: item?.sellingPrice,
              gtin: item?.gtin,
              batch: item?.batchNo,
              quantity: item?.availableUnits,
              batchNum: item?.batchNo,
              offers: item.offersList ? item : null,
              purchasePrice: item?.purchasePrice,
              isMultiple: item?.multipleBatches,
            };
          });
          setMrps(dataArr);
          setOfferData(dataArr[0]?.offers);
          setSelectedMrp(dataArr[0]?.mrp);
          setSelectedSellingPrice(dataArr[0]?.sellingPrice);
          setBatchNo(dataArr[0]?.batchNum);
          setPurchasePrice(dataArr[0]?.purchasePrice || "");
          setSelectedGtin(dataArr[0]?.gtin);
          // setSellingUnit(dataArr[0].sellingUnit);
          setSelectedProduct(name);
          setOpen(false);
          setOpenModal(true);
          setanimationBox(true);
          setItemgtin(gtin);
          setHighlightMrp(dataArr[0]?.sellingPrice);
        }
        //handling error with er other than 0
        else if (res?.data?.data?.es !== 0) {
          setAddItemThroughParticularCategoryItemLoader(null);
          showSnackbar(res?.data?.data?.message, "error");
        } else {
          const response = res?.data?.data?.data;
          const sortedCartProducts = response?.cartProducts?.sort((a, b) =>
            b.modifiedDate.localeCompare(a.modifiedDate)
          );

          applyCartState(response, sortedCartProducts);

          // ── Complimentary flow ──────────────────────────────────────────
          // After item is in cart, immediately call the complimentary API
          // to mark it as complimentary using the new cartProductId.
          if (isComplimentary && sortedCartProducts?.[0]?.cartProductId) {
            const compPayload = {
              locationId: locId,
              cartId: cartId,
              cartProducts: { [sortedCartProducts[0]?.cartProductId]: restaurantPayload?.qty },
              markWholeCart: false,
              updatedBy: retailUserLocalStorageData?.uidx,
              updatedByName: retailUserLocalStorageData?.firstName,
            };
            complimentaryCart(compPayload)
              .then((compRes) => {
                if (
                  compRes?.data?.data?.es > 0 ||
                  compRes?.data?.status === "ERROR" ||
                  compRes?.data?.data?.status === "ERROR"
                ) {
                  showSnackbar(
                    compRes?.data?.data?.message ||
                      "Item added but could not mark as complimentary",
                    "warning"
                  );
                  return;
                }
                const compData = compRes?.data?.data?.data;
                if (compData) {
                  const compSorted = compData?.cartProducts?.sort((a, b) =>
                    b.modifiedDate.localeCompare(a.modifiedDate)
                  );
                  applyCartState(compData, compSorted);
                }
                showSnackbar("Complimentary item added", "success");
              })
              .catch(() => {
                showSnackbar("Item added but could not mark as complimentary", "warning");
              });
          }
          // ───────────────────────────────────────────────────────────────

          setAppliedState(!appliedState);
          setAddItemThroughParticularCategoryItemLoader(null);
          setSelectedMrp("");
          setOpenProductList(false);
          setGoToMobileCategory(false);
          setSelectedSellingPrice("");
          setBatchNo("");
          setPurchasePrice("");
          setSelectedGtin("");
          setSelectedProduct("");
          setOfferData(null);
          setMrps([]);
          setanimationBox(true);
          setItemgtin(gtin);
          setHighlightMrp(response?.cartProducts?.[0]?.sellingPrice);
          setOpen(false);
          dispatch(searchTextRes(""));
          const currentTime = new Date().getTime();
          setMannuallyEnteredProduct(mannuallyEnteredProduct + 1);
          dispatch(incrementManuallyAddedProduct(mannuallyEnteredProduct + 1));
          dispatch(setTotalProducts(totalProducts + 1));
          dispatch(changePrevAddedTime(currentTime));
          dispatch(addingProductTime(currentTime - initialTime));
          dispatch(addManualItemsGTIN(gtin));
          const backupData = {
            ...orderMetricDataFullState,
            manuallyAdded: mannuallyEnteredProduct + 1,
            totalProducts: totalProducts + 1,
            prevAddedProductTime: currentTime,
            productTimeArray: [
              ...orderMetricDataFullState.productTimeArray,
              currentTime - initialTime,
            ],
            manualItemsGtin: orderMetricDataFullState.manualItemsGtin.includes(gtin)
              ? [...orderMetricDataFullState.manualItemsGtin]
              : [...orderMetricDataFullState.manualItemsGtin, gtin],
          };
          localStorage.setItem("orderMetricData", JSON.stringify(backupData));
        }
      });
    } else {
      // Error handling (stale cart, no cart, generic) delegated to useAddToCart hook
      addItemWithCheck(payload, {
        onBeforeError: () => {
          setIsBatchSelected(false);
          setAddItemThroughParticularCategoryItemLoader(null);
        },
        onBatchSelect: (dataArr) => {
          setIsBatchSelected(true);
          if (isProfilerOn) {
            const end = new Date().getTime();
            const timeTaken = end - start;
            const updatedResponseTimes = [
              ...addItemResponseTime,
              { time: end, responseTime: timeTaken },
            ];
            localStorage.setItem("addItemResponseTime", JSON.stringify(updatedResponseTimes));
            setAddItemResponseTime(updatedResponseTimes);
          }
          dispatch(changeMultipleBatchesValue(true));
          localStorage.setItem(
            "orderMetricData",
            JSON.stringify({
              ...orderMetricDataFullState,
              isMultipleBatch: true,
            })
          );
          setBrandName(dataArr?.[0]?.brand);
          setPackagingType(dataArr?.[0]?.packagingType);
          setVariantName(dataArr?.[0]?.variantName);
          setVendorId(dataArr?.[0]?.vendorId);
          setExpiryDate(dataArr?.[0]?.expiryDate || "");
          setMrps(dataArr);
          setOfferData(dataArr?.[0]?.offers);
          setSelectedMrp(dataArr?.[0]?.mrp);
          setSelectedSellingPrice(dataArr?.[0]?.sellingPrice);
          setBatchNo(dataArr?.[0]?.batchNum);
          setPurchasePrice(dataArr?.[0]?.purchasePrice || "");
          setSelectedGtin(dataArr?.[0]?.gtin);
          setSellingUnit(dataArr?.[0]?.sellingUnit);
          setSelectedProduct(name);
          setOpen(false);
          setOpenModal(true);
          setanimationBox(true);
          setItemgtin(gtin);
          setHighlightMrp(dataArr?.[0]?.sellingPrice);
        },
        onSuccess: (response) => {
          // Cart state (cartItems, billing, offerFound) applied by useAddToCart hook
          setIsBatchSelected(true);
          if (isProfilerOn) {
            const end = new Date().getTime();
            const timeTaken = end - start;
            const updatedResponseTimes = [
              ...addItemResponseTime,
              { time: end, responseTime: timeTaken },
            ];
            localStorage.setItem("addItemResponseTime", JSON.stringify(updatedResponseTimes));
            setAddItemResponseTime(updatedResponseTimes);
          }
          // Highlight the most recently modified product
          const sortedCartProducts = [...(response?.cartProducts || [])].sort((a, b) =>
            (b.modifiedDate || b.createdDate || "").localeCompare(
              a.modifiedDate || a.createdDate || ""
            )
          );
          if (sortedCartProducts?.[0]?.cartProductId) {
            setHighlightedCartProductId(sortedCartProducts[0].cartProductId);
            setTimeout(() => setHighlightedCartProductId(null), 2000);
          }
          setTotalTaxes(response?.billing?.tax);
          setTotalValue(response?.billing?.totalValue);
          setCouponApplied(response?.billing?.appliedCoupon);
          setContextCouponApplied(response?.billing?.appliedCoupon || "0");
          dispatch(addcoupon(response?.cartCoupon || null));
          setAppliedState(!appliedState);
          setAddItemThroughParticularCategoryItemLoader(null);
          setSelectedMrp("");
          setSelectedSellingPrice("");
          setBatchNo("");
          setPurchasePrice("");
          setSelectedGtin("");
          setSelectedProduct("");
          setOfferData(null);
          setMrps([]);
          setanimationBox(true);
          setItemgtin(gtin);
          setHighlightMrp(sortedCartProducts?.[0]?.sellingPrice);
          setOpen(false);
          dispatch(searchTextRes(""));
          const currentTime = new Date().getTime();
          setMannuallyEnteredProduct(mannuallyEnteredProduct + 1);
          dispatch(incrementManuallyAddedProduct(mannuallyEnteredProduct + 1));
          dispatch(setTotalProducts(totalProducts + 1));
          dispatch(changePrevAddedTime(currentTime));
          dispatch(addingProductTime(currentTime - initialTime));
          dispatch(addManualItemsGTIN(gtin));
          const backupData = {
            ...orderMetricDataFullState,
            manuallyAdded: mannuallyEnteredProduct + 1,
            totalProducts: totalProducts + 1,
            prevAddedProductTime: currentTime,
            productTimeArray: [
              ...orderMetricDataFullState.productTimeArray,
              currentTime - initialTime,
            ],
            manualItemsGtin: orderMetricDataFullState.manualItemsGtin.includes(gtin)
              ? [...orderMetricDataFullState.manualItemsGtin]
              : [...orderMetricDataFullState.manualItemsGtin, gtin],
          };
          localStorage.setItem("orderMetricData", JSON.stringify(backupData));
        },
      });
    }
  };

  const isProfilerOn = localStorage.getItem("profilerSwitch") === "true";
  const [batchNo, setBatchNo] = useState("");
  const [purchasePrice, setPurchasePrice] = useState("");
  const [complimentaryMode, setComplimentaryMode] = useState(false);

  const addItem = async (
    gtin,
    mrp,
    sp,
    batchNo,
    purchasePrice,
    offer,
    brandName,
    packagingType,
    variantName,
    vendorId,
    expiryDate,
    sellingUnit
  ) => {
    setHighlightMrp(sp);
    setOpenModal(false);
    // let payload = {
    //   cartId: cartId,
    //   gtin: selectedGtin || gtin,
    // };
    const start = new Date().getTime();

    let payload = {
      cartId: cartId,
      sellingPrice: sp,
      gtin: gtin,
      locationId: locId,
      mrp: mrp,
      inventoryChecks: "NO",
      batchNo: batchNo,
      purchasePrice: purchasePrice,
      isOfferAvailable: offer?.length > 0 ? true : false,

      sellingUnit: sellingUnit,
      expiryDate: expiryDate?.split("+")[0],
      variantName: variantName,
      vendorId: vendorId,
      packagingType: packagingType,
      brandName: brandName,
    };

    // Error handling (stale cart, no cart, generic) delegated to useAddToCart hook
    await addItemDirect(payload, cartItems, {
      onBeforeError: () => {
        setAddItemThroughParticularCategoryItemLoader(null);
      },
      onError: (errMsg) => {
        showSnackbar(errMsg, "error");
      },
      onSuccess: (cartData) => {
        setIsBatchSelected(false);
        //cart-response-times
        if (isProfilerOn) {
          const end = new Date().getTime();
          const timeTaken = end - start;
          const updatedResponseTimes = [
            ...responseCartTimes,
            { time: end, responseTime: timeTaken },
          ];
          localStorage.setItem("responseCartTimes", JSON.stringify(updatedResponseTimes));
          setResponseCartTimes(updatedResponseTimes);
        }
        if (multipleBatchCheck) {
          const currentTime = new Date().getTime();
          setMannuallyEnteredProduct(mannuallyEnteredProduct + 1);
          dispatch(incrementManuallyAddedProduct(mannuallyEnteredProduct + 1));
          dispatch(setTotalProducts(totalProducts + 1));
          dispatch(addingProductTime(currentTime - start));
          dispatch(changeMultipleBatchesValue(false));
          dispatch(addManualItemsGTIN(selectedGtin || gtin));
          const backupData = {
            ...orderMetricDataFullState,
            manuallyAdded: mannuallyEnteredProduct + 1,
            isMultipleBatch: false,
            totalProducts: totalProducts + 1,
            productTimeArray: [...orderMetricDataFullState?.productTimeArray, currentTime - start],
            manualItemsGtin: orderMetricDataFullState?.manualItemsGtin?.includes(
              selectedGtin || gtin
            )
              ? [...orderMetricDataFullState?.manualItemsGtin]
              : [...orderMetricDataFullState?.manualItemsGtin, selectedGtin || gtin],
          };
          localStorage.setItem("orderMetricData", JSON.stringify(backupData));
        }
        showSnackbar("Item added successfully", "success");
        // hook's applyCartState already applied cartItems, billing, offerFound
        // set the extra fields not covered by the hook:
        setTotalTaxes(cartData?.billing?.tax);
        setTotalValue(cartData?.billing?.totalValue);
        setCouponApplied(cartData?.billing?.appliedCoupon);
        setContextCouponApplied(cartData?.billing?.appliedCoupon || "0");
        dispatch(addcoupon(cartData?.cartCoupon || null));
        setAppliedState(!appliedState);
        setAddItemThroughParticularCategoryItemLoader(null);
        setSelectedMrp("");
        setBatchNo("");
        setPurchasePrice("");
        setSelectedSellingPrice("");
        setSelectedGtin("");
        setSelectedProduct("");
        setMrps([]);
        setanimationBox(true);
        setItemgtin(gtin);
        setHighlightMrp(cartData?.cartProducts?.[0]?.sellingPrice);

        const appliedBy = retailUserLocalStorageData?.uidx || "";
        const appliedByName =
          [retailUserLocalStorageData?.firstName, retailUserLocalStorageData?.secondName]
            .filter(Boolean)
            .join(" ") || "";

        setDiscountResetSignal((prev) => prev + 1);

        applyOrderLevelDiscount({
          cartId: cartData?.cartId || cartId,
          discountType: "NONE",
          discount: 0,
          appliedBy,
          appliedByName,
        })
          .then((discountRes) => {
            const updatedCart =
              discountRes?.data?.data?.data ||
              discountRes?.data?.data?.cartData ||
              discountRes?.data?.data;
            if (!updatedCart?.billing) return;
            const sortedUpdatedProducts = [...(updatedCart?.cartProducts || [])].sort((a, b) =>
              (b?.modifiedDate || "").localeCompare(a?.modifiedDate || "")
            );
            setCartItems(sortedUpdatedProducts);
            setOfferFound(!!updatedCart?.offerProductFound);
            setCgst(updatedCart?.billing?.cgst);
            setSgst(updatedCart?.billing?.sgst);
            setCess(updatedCart?.billing?.totalCessAmount);
            setTotal(updatedCart?.billing?.totalCartValue);
            setSubTotal(updatedCart?.billing?.subtotal);
            setTotalTaxes(updatedCart?.billing?.tax);
            setTotalValue(updatedCart?.billing?.totalValue);
          })
          .catch(() => {});
      },
    });
  };

  useEffect(() => {
    if (!standardProductsEnabled) return;
    setparticularCategoryItems(productsData);
    setPage(1);
    setNoresults(productsData.length === 0);
    firstTimeSearchRef.current = false;
  }, [productsData, standardProductsEnabled]);

  useEffect(() => {
    if (currentFoodType !== "HOT_SELLING") return;
    setparticularCategoryItems(hotSellingData);
    setPage(1);
    setNoresults(hotSellingData.length === 0);
  }, [currentFoodType, hotSellingData]);

  useEffect(() => {
    const error = currentFoodType === "HOT_SELLING" ? hotSellingError : productsError;
    if (error) {
      showSnackbar(error?.response?.data?.message || "Failed to fetch products", "error");
    }
  }, [currentFoodType, hotSellingError, productsError]);

  // Reset filters when saleMode changes
  useEffect(() => {
    setActiveFilter("ALL");
    setCurrentFoodType("");
  }, [saleMode]);

  useEffect(() => {
    firstTimeSearchRef.current = true;
    setSearchText("");
    setSearchActive(false);
    setPage(1);
    setCategoryName("");
    categoryResetPendingRef.current = false;
    return () => {
      firstTimeSearchRef.current = true;
    };
  }, []);

  const handleModalClose = () => {
    setIsBatchSelected(false);
    setOpenModal(false);
    setAddItemThroughParticularCategoryItemLoader(null);
  };

  const handleAddProduct = async ({ itemName, sellingPrice, prepStationId, prepStationName }) => {
    setAddProductLoader(true);
    try {
      const appConfig = JSON.parse(localStorage.getItem("appConfig") || "{}");
      const menuConfig = appConfig?.settings?.CREATION_OF_MENU?.settings || {};
      const userDetails = JSON.parse(localStorage.getItem("retailUserDetails") || "{}");
      const updatedByName = [userDetails?.firstName, userDetails?.secondName]
        .filter(Boolean)
        .join(" ");

      const payload = {
        cartId,
        name: itemName,
        qty: 1,
        sellingPrice,
        purchasePrice: sellingPrice,
        sellingUnit: "PCS",
        ...(menuConfig.foodType && { foodType: menuConfig.foodType }),
        ...(menuConfig.hsn && { hsnCode: menuConfig.hsn }),
        ...(menuConfig.gst != null && { gst: menuConfig.gst }),
        ...(menuConfig.cess != null && { cess: menuConfig.cess }),
        ...(menuConfig.categoryLevel1Name && { mainCategory: menuConfig.categoryLevel1Name }),
        ...(menuConfig.categoryLevel1Name && { level1Category: menuConfig.categoryLevel1Name }),
        ...(menuConfig.categoryLevel2Name && { level2Category: menuConfig.categoryLevel2Name }),
        ...(prepStationId && { prepStationId }),
        ...(prepStationName && { prepStationName }),
        ...(userDetails?.uidx && { updatedBy: userDetails.uidx }),
        ...(updatedByName && { updatedByName }),
      };
      const res = await addOpenProductToCart(payload);
      if (res?.data?.es === 1) {
        showSnackbar(res?.data?.message || "Failed to add product", "error");
      } else {
        const cartData = res?.data?.data?.data;
        const billing = cartData?.billing;
        const sortedProducts = [...(cartData?.cartProducts || [])].sort((a, b) =>
          b?.modifiedDate?.localeCompare(a?.modifiedDate)
        );
        setCartItems(sortedProducts);
        if (sortedProducts[0]?.cartProductId) {
          setHighlightedCartProductId(sortedProducts[0].cartProductId);
          setTimeout(() => setHighlightedCartProductId(null), 2000);
        }
        setOfferFound(!!cartData?.offerProductFound);
        setCgst(billing?.cgst);
        setSgst(billing?.sgst);
        setCess(billing?.totalCessAmount);
        setTotal(billing?.totalCartValue);
        setSubTotal(billing?.subtotal);
        setTotalTaxes(billing?.tax);
        setTotalValue(billing?.totalValue);
        setCartTotalQty(billing?.quantity);

        showSnackbar(`"${itemName}" added to cart`, "success");
        setAddProductModal(false);
      }
    } catch {
      showSnackbar("Failed to add product", "error");
    } finally {
      setAddProductLoader(false);
    }
  };

  const handlePrice = (mrp, sp, batchNo, purchasePrice, offer) => {
    setSelectedMrp(mrp);
    setSelectedSellingPrice(sp);
    setBatchNo(batchNo);
    setPurchasePrice(purchasePrice);
    setOfferData(offer);
    setIsBatchSelected(true);
  };

  // ── handleProductAction — shared add-to-cart logic for a single product ─────
  // Used by both CartProductSection (onClick) and the keyboard Enter handler.
  const handleProductAction = (ele, index) => {
    if (!ele) return;
    const barcodes = ele?.variants?.[0]?.barcodes?.[0];
    const name = ele?.name;
    const selectedSaleChannel = ele?.isBundle
      ? ele?.externalSalesChannels?.find((ch) => ch?.salesChannelName === saleMode)
      : ele?.variants?.[0]?.externalSalesChannels?.find((ch) => ch?.salesChannelName === saleMode);
    const sellingPrice = ele?.isBundle
      ? selectedSaleChannel?.salePrice ?? ele?.bundlePrice ?? null
      : selectedSaleChannel?.salePrice || ele?.variants?.[0]?.inventorySync?.sellingPrice;
    const isSingleVariantAndNoAddOns =
      ele?.variants?.length === 1 &&
      (!ele?.variants?.[0]?.addOn || ele?.variants?.[0]?.addOn?.length === 0);

    if (ele?.isBundle) {
      setComboModalProduct(ele);
      setComboModalPrice(sellingPrice);
      setComboModalIndex(index);
      setComboModalOpen(true);
    } else if (isSingleVariantAndNoAddOns || ele?.needsWeighingScaleIntegration) {
      increseItemQuantityTroughParticularCategory(
        barcodes,
        name,
        index,
        ele?.needsWeighingScaleIntegration ? "weighingScale" : "Standard",
        ele?.variants?.[0]?.weightUnit,
        ele?.variants?.[0]?.variantId,
        sellingPrice
      );
    } else {
      const addOnsList = ele?.variants?.[0]?.addOn ?? [];
      setAddOnProductList(addOnsList);
      setVariantProductList(ele?.variants);
      setSelectedProductForCart({
        id: ele?.id || "",
        barcodes,
        name,
        index,
        packaging_type: ele?.packaging_type,
        sellingUnit: ele?.sellingUnit,
        variantId: ele?.variants?.[0]?.variantId,
        sellingPrice,
        variants: ele?.variants,
        description: ele?.description || "",
      });
      setAddOnModalOpen(true);
    }
  };

  // Single filter-selection path shared by filter chips and keyboard shortcuts.
  const handleFilters = (filter, foodType, options = {}) => {
    const restaurantOnlyFilter = ["VEG", "NON_VEG", "COMBOS", "HOT_SELLING"].includes(filter);
    if (retailType !== "RESTAURANT" && restaurantOnlyFilter) return;
    if (activeFilter === filter) return;

    const { preserveSearch = false } = options;

    setActiveFilter(filter);
    setCurrentFoodType(foodType);
    setPage(1);

    if (!preserveSearch) {
      setSearchText("");
      setSearchActive(false);
    }

    if (filter === "ALL") {
      setCategoryName("");
      setSelectedCategory("");
    }
  };

  // ── Keep keyboard-handler refs current on every render ──────────────────────
  addOnModalOpenRef.current = addOnModalOpen;
  categoryModalOpenRef.current = categoryModalOpen;
  filterSelectionRef.current = handleFilters;
  focusedProductIndexRef.current = focusedProductIndex;
  particularCategoryItemsRef.current = particularCategoryItems;
  handleProductActionRef.current = handleProductAction;

  // Reset product focus whenever the product list changes
  useEffect(() => {
    setFocusedProductIndex(-1);
  }, [particularCategoryItems]); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Keyboard shortcuts for restaurant cart ───────────────────────────────────
  // Registered once (empty deps). Stale-closure safety is handled via refs above.
  useEffect(() => {
    const handleKeyDown = (e) => {
      const tag = document.activeElement?.tagName?.toUpperCase();
      const isTyping = tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT";

      // F3 — Focus search bar and reset all filters
      if (e.key === "F3") {
        e.preventDefault();
        setFocusedProductIndex(-1);
        const searchInput = document.getElementById("search-input");
        if (searchInput) {
          setSelectedCategory("");
          setparticularCategoryItems([]);
          setPage(1);
          setActiveFilter("ALL");
          setCurrentFoodType("");
          setSearchText("");
          setCategoryName("");
          searchInput.focus();
        }
        return;
      }

      // Escape — close open modal, or deselect keyboard-focused product
      if (e.key === "Escape") {
        if (addOnModalOpenRef.current) {
          setAddOnModalOpen(false);
          return;
        }
        if (categoryModalOpenRef.current) {
          setCategoryModalOpen(false);
          return;
        }
        setFocusedProductIndex(-1);
        return;
      }

      // Block all remaining shortcuts while addon or category modal is open
      if (addOnModalOpenRef.current || categoryModalOpenRef.current) return;

      // Remaining shortcuts should not fire while the user is typing
      if (isTyping) return;

      const items = particularCategoryItemsRef.current;
      const currentIdx = focusedProductIndexRef.current;

      // Arrow keys — navigate through products (ignore when Alt is held, reserved for cart item navigation)
      if (!e.altKey && (e.key === "ArrowDown" || e.key === "ArrowRight")) {
        e.preventDefault();
        setFocusedProductIndex((prev) => Math.min(prev + 1, items.length - 1));
        return;
      }
      if (!e.altKey && (e.key === "ArrowUp" || e.key === "ArrowLeft")) {
        e.preventDefault();
        setFocusedProductIndex((prev) => (prev <= 0 ? 0 : prev - 1));
        return;
      }

      // Enter — trigger add-to-cart for the focused product
      // Skip if a cart item is keyboard-focused (its own Enter handler will run)
      if (e.key === "Enter") {
        if (document.querySelector(".cart-item-keyboard-focused")) return;
        if (currentIdx >= 0 && currentIdx < items.length) {
          e.preventDefault();
          if (!e.repeat) {
            handleProductActionRef.current?.(items[currentIdx], currentIdx);
          }
        }
        return;
      }

      // Alt + key — food-type filter shortcuts
      // Alt+A → All  |  Alt+V → Veg  |  Alt+N → Non-Veg
      // Alt+C → Combos  |  Alt+B → Bestseller
      if (e.altKey) {
        if (retailType !== "RESTAURANT") return;
        const FILTER_MAP = {
          a: { filter: "ALL", foodType: "" },
          v: { filter: "VEG", foodType: "VEG" },
          n: { filter: "NON_VEG", foodType: "NON_VEG" },
          c: { filter: "COMBOS", foodType: "COMBOS" },
          b: { filter: "HOT_SELLING", foodType: "HOT_SELLING" },
        };
        const entry = FILTER_MAP[e.key.toLowerCase()];
        if (!entry) return;
        e.preventDefault();
        filterSelectionRef.current?.(entry.filter, entry.foodType);
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  //Open Category Modal.
  const handleCategoryModalOpen = () => {
    setCategoryModalOpen(true);
  };

  return (
    <>
      <Navbar
        pageTitle={"Cart"}
        goToMobileCategory={goToMobileCategory}
        setGoToMobileCategory={setGoToMobileCategory}
      >
        <Box className={color} style={{ display: "flex", flex: 1, flexDirection: "column" }}>
          {searchText && isMobile && <DropDownModal />}
          {isMobile && goToMobileCategory && (
            <MobileCategoryPage
              goToMobileCategory={goToMobileCategory}
              setGoToMobileCategory={setGoToMobileCategory}
              increseItemQuantityTroughParticularCategory={
                increseItemQuantityTroughParticularCategory
              }
              setAddOnModalOpen={setAddOnModalOpen}
              setAddOnProductList={setAddOnProductList}
              setVariantProductList={setVariantProductList}
              setSelectedProductForCart={setSelectedProductForCart}
              addItemLoader={addItemThroughParticularCategoryItemLoader}
              setAddItemLoader={setAddItemThroughParticularCategoryItemLoader}
              openProductList={openProductList}
              setOpenProductList={setOpenProductList}
            />
          )}
          {renderWeighingModal()}
          {openModal && (
            <div>
              <Modal open={openModal} onClose={handleModalClose}>
                <Box
                  sx={{
                    backgroundColor: color === "dark" ? "#353a50" : "#fff",
                    color: color === "dark" ? "white" : "black",
                    position: isMobile ? "static" : "relative",
                    width: isMobile ? "100%" : "40%",
                    maxWidth: "100vw",
                    maxHeight: isMobile ? "100%" : "90%",
                    transform: isMobile ? "none" : "translate(50%, -50%)",
                    borderRadius: "10px",
                    top: "50%",
                    left: "10%",
                    overflowY: "auto",
                    ...(isMobile && {
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                    }),
                  }}
                >
                  <div className="sticky-box-mrp">
                    <div style={{ width: "100%" }}>
                      <IconButton sx={{ float: "right" }} onClick={handleModalClose}>
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </div>

                    <div className="gtin-wrapper-box">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <h5 className="text-mrp-heading" style={{ color: "gray" }}>
                          {selectedProduct} -&nbsp;
                        </h5>
                        <p style={{ color: "gray", fontWeight: "600" }}>{selectedGtin}</p>
                      </div>
                    </div>
                  </div>
                  <div className="mrp-option-wrapper-box">
                    {/* {mrps?.filter((mrp) => mrp?.offers === null)?.length == 0 ? null : ( */}
                    <p>Batches</p>
                    {/* )} */}
                    {mrps?.map((mrp, i) => (
                      <div key={i} className="select-mrp-wrapper-box">
                        <input
                          name="mrp"
                          key={mrp.mrp}
                          value={mrp.mrp}
                          id={`mrp-${i}`}
                          type="radio"
                          onChange={(e) =>
                            handlePrice(
                              mrp?.mrp,
                              mrp?.sellingPrice,
                              mrp?.batchNum,
                              mrp?.purchasePrice,
                              mrp?.offers
                            )
                          }
                        />
                        <div className="select-items-container">
                          <label style={{ cursor: "pointer" }} htmlFor={`mrp-${i}`}>
                            <p style={{ fontWeight: "bold" }}>
                              {mrp.mrp >= mrp.sellingPrice ? (
                                <b className="strike-off-mrp">&nbsp;₹{mrp.mrp}&nbsp;</b>
                              ) : null}
                              <b>&nbsp;&nbsp;</b>₹{mrp.sellingPrice}
                            </p>
                            <p className="select-item-details">Available Units : {mrp.quantity}</p>
                            <p className="select-item-details">Batch : {mrp.batch}</p>
                          </label>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="mrp-popup-box">
                    <button className="mrp-cancel-btn" onClick={handleModalClose}>
                      Cancel
                    </button>
                    <button
                      className="mrp-btn"
                      disabled={!isBatchSelected}
                      onClick={() => {
                        addItem(
                          selectedGtin,
                          selectedMrp,
                          SelectedSellingPrice,
                          batchNo,
                          purchasePrice,
                          offerData,
                          brandName,
                          packagingType,
                          variantName,
                          vendorId,
                          expiryDate,
                          sellingUnit
                        );
                      }}
                    >
                      Select
                    </button>
                  </div>
                </Box>
              </Modal>
            </div>
          )}
          {open ? (
            <div>
              <Modal open={open}>
                <Box
                  sx={{
                    backgroundColor: color === "dark" ? "#353a50" : "#fff",
                    color: color === "dark" ? "white" : "black",
                    position: isMobile ? "static" : "fixed",
                    top: "50%",
                    left: "10%",
                    maxWidth: isMobile ? "100%" : "40%",
                    maxHeight: "100%",
                    transform: isMobile ? "none" : "translate(50%, -50%)",
                    width: isMobile ? "100%" : "50%",
                    display: isMobile ? "flex" : "block",
                    borderRadius: "10px",
                    padding: "1.5rem",
                    flexDirection: "column",
                    justifyContent: "center",
                    ...(isMobile && { height: "100%" }),
                  }}
                >
                  <h3 className="addCustomerText" style={{ marginBottom: "3vh" }}>
                    Add Customer For The Orders
                  </h3>

                  <FormControl
                    variant="standard"
                    sx={{
                      width: "100%",
                    }}
                  >
                    <BootstrapInput
                      placeholder="Enter Mobile Number"
                      id="bootstrap-input"
                      autoFocus
                      type="number"
                      minLength={10}
                      maxLength={10}
                      value={customerMobileNumber}
                      onChange={(e) => setCustomerMobileNumber(e.target.value)}
                    />
                  </FormControl>
                  <label htmlFor="checkbox">
                    <div className="check-wrapper-box">
                      <input
                        type="checkbox"
                        id="checkbox"
                        checked={whatsAppCheck}
                        onChange={(e) => {
                          setWhatsAppCheck(e.target.checked);
                        }}
                      />
                      <WhatsAppIcon className="whats-app-logo" />
                      <span className="restore-text">Get notification on whatsapp</span>
                    </div>
                  </label>
                  <p
                    style={{
                      fontSize: "0.7rem",
                      color: "#6b7280",
                      margin: "4px 0 8px",
                      lineHeight: 1.4,
                    }}
                  >
                    Sending WhatsApp notifications requires a WhatsApp API integration. Connect your
                    own number, or subscribe to a{" "}
                    <strong style={{ fontWeight: 600 }}>Pallet Notifications plan</strong> to send
                    messages via a Pallet-managed number.
                  </p>
                  <FormControl
                    variant="standard"
                    sx={{
                      width: "100%",
                      marginTop: "1rem",
                    }}
                  >
                    <BootstrapInput
                      placeholder="Enter Name"
                      id="bootstrap-input"
                      value={customerName}
                      onChange={(e) => setCustomerName(e.target.value)}
                    />
                  </FormControl>
                  <div className="check-wrapper-box">
                    <input type="radio" name="check" checked />
                    <LocalShippingIcon className="whats-app-logo-I" />
                    <span className="restore-text">In-store</span>
                    <input type="radio" name="check" disabled />
                    <StoreIcon className="whats-app-logo-I" />
                    <span className="del-text">Delivery</span>
                  </div>

                  <div className="skipBtnContainer">
                    <Stack direction="column" spacing={2}>
                      <div className="btn-container">
                        <StyledButton onClick={handleClose} loading={skipModelLoader} color="gray">
                          <p>Skip</p> <KeyboardArrowRightIcon fontSize="small" />
                        </StyledButton>

                        <StyledButton onClick={addCustomerFun} loading={addModelLoader}>
                          <p>Add</p> <ControlPointIcon fontSize="small" />
                        </StyledButton>
                      </div>

                      {/* <div
                            onClick={() => navigate("/products/holdorderpage")}
                            className="popUpSkipBtn"
                          >
                            <button className="skip-btn">Hold</button>
                          </div> */}
                    </Stack>
                  </div>
                </Box>
              </Modal>
            </div>
          ) : (
            <div
              className="particular-cat-container pcp-outer"
              style={{ width: appDrawer ? "calc(100vw - 85px)" : "100%" }}
            >
              <div className="pcp-layout">
                {/* ─── Panel 1: Categories ─── */}
                {!isMobile && (
                  <>
                    <div className="pcp-category-panel" style={{ width: categoryPanelWidth }}>
                      <div className="pcp-category-body">
                        {data?.length > 0 && (
                          <CategoryOptionsPage
                            data={data}
                            selectedCategory={selectedCategory}
                            variant="replitPanel"
                            onCategoryClick={(newCategoryName) => {
                              setPage(1);
                              setActiveFilter("ALL");
                              setCurrentFoodType("");
                              setSearchText("");
                              setSelectedCategory(newCategoryName);
                              setCategoryName(newCategoryName);
                            }}
                            height="calc(100vh - 110px)"
                          />
                        )}
                      </div>
                    </div>
                    <div className="pcp-resizer" onMouseDown={startResizingCategory}>
                      <div className="pcp-resizer-handle">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          aria-hidden="true"
                        >
                          <circle cx="9" cy="12" r="1"></circle>
                          <circle cx="9" cy="5" r="1"></circle>
                          <circle cx="9" cy="19" r="1"></circle>
                          <circle cx="15" cy="12" r="1"></circle>
                          <circle cx="15" cy="5" r="1"></circle>
                          <circle cx="15" cy="19" r="1"></circle>
                        </svg>
                      </div>
                    </div>
                  </>
                )}

                {/* ─── Panel 2: Products ─── */}
                {!isMobile && (
                  <div className="pcp-products-panel">
                    <div className={`customHeaderContainer ${color === "dark" ? "dark" : ""}`}>
                      {retailType === "RESTAURANT" && (
                        <div className={`searchbarContainer ${color === "dark" ? "dark" : ""}`}>
                          {[
                            {
                              key: "ALL",
                              label: "All",
                              icon: null,
                              foodType: "",
                              activeColor: "#0860e6",
                            },
                            {
                              key: "VEG",
                              label: "Veg",
                              icon: (
                                <img
                                  src={vegIcon}
                                  alt="veg"
                                  style={{ width: "14px", height: "14px" }}
                                />
                              ),
                              foodType: "VEG",
                              activeColor: "#16a34a",
                            },
                            {
                              key: "NON_VEG",
                              label: "Non Veg",
                              icon: (
                                <img
                                  src={nonVegIcon}
                                  alt="non-veg"
                                  style={{ width: "14px", height: "14px" }}
                                />
                              ),
                              foodType: "NON_VEG",
                              activeColor: "#dc2626",
                            },
                            {
                              key: "COMBOS",
                              label: "Combos",
                              icon: <span style={{ fontSize: "13px", lineHeight: 1 }}>🍱</span>,
                              foodType: "COMBOS",
                              activeColor: "#9333ea",
                            },
                            {
                              key: "HOT_SELLING",
                              label: "Bestseller",
                              icon: <span style={{ fontSize: "13px", lineHeight: 1 }}>🔥</span>,
                              foodType: "HOT_SELLING",
                              activeColor: "#ea580c",
                            },
                          ].map(({ key, label, icon, foodType, activeColor }) => {
                            const isActive = activeFilter === key;
                            return (
                              <button
                                key={key}
                                onClick={() => handleFilters(key, foodType)}
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "5px",
                                  padding: "10px 16px",
                                  borderRadius: "999px",
                                  border: isActive
                                    ? "none"
                                    : `1.5px solid ${color === "dark" ? "#334155" : "#e5e7eb"}`,
                                  background: isActive ? `${activeColor}22` : "transparent",
                                  color: isActive
                                    ? activeColor
                                    : color === "dark"
                                    ? "#94a3b8"
                                    : "#4b5563",
                                  fontSize: "0.78rem",
                                  fontWeight: isActive ? 700 : 500,
                                  cursor: "pointer",
                                  whiteSpace: "nowrap",
                                  flexShrink: 0,
                                  transition: "all 0.15s ease",
                                  outline: "none",
                                  boxShadow: "none",
                                }}
                              >
                                {icon}
                                {label}
                              </button>
                            );
                          })}
                        </div>
                      )}
                      <div className="newSearchContainer">
                        <section className="newSearchContainerLeftSection">
                          <div className="customSearchBar-div">
                            <CommonSearchBar
                              queryManagedProducts
                              setSelectedCategory={setSelectedCategory}
                              selectedCategory={selectedCategory}
                              handleFilters={handleFilters}
                              activeFilter={activeFilter}
                            />
                          </div>
                        </section>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            flexShrink: 0,
                          }}
                        >
                          <CartViewLayoutSection
                            layoutType={layoutType}
                            setLayoutType={handleLayoutTypeChange}
                            onEditModeClick={() => showSnackbar("Feature coming soon", "info")}
                          />
                        </div>
                      </div>
                    </div>

                    {(layoutType === "cardViewLayout" ||
                      layoutType === "rowViewLayout" ||
                      layoutType === "listViewLayout") && (
                      <div
                        ref={gridRef}
                        id="mainHeader"
                        className="particularCategoryEachItemGridContainerCFSCartPage"
                      >
                        {data?.length > 0 || loader || searchLoader ? (
                          <div ref={setProductListContainerRefs} className="forGridItem">
                            <CartProductSection
                              layoutType={layoutType}
                              loader={loader}
                              productsRefreshing={productsRefreshing}
                              searchLoader={searchLoader}
                              particularCategoryItems={particularCategoryItems}
                              retailType={retailType}
                              color={color}
                              complimentaryMode={complimentaryMode}
                              increseItemQuantityTroughParticularCategory={
                                increseItemQuantityTroughParticularCategory
                              }
                              addItemThroughParticularCategoryItemLoader={
                                addItemThroughParticularCategoryItemLoader
                              }
                              setAddOnModalOpen={setAddOnModalOpen}
                              setAddOnProductList={setAddOnProductList}
                              setVariantProductList={setVariantProductList}
                              setSelectedProductForCart={setSelectedProductForCart}
                              saleMode={saleMode}
                              focusedProductIndex={focusedProductIndex}
                              handleProductAction={handleProductAction}
                              observerTargetIndex={observerTargetIndex}
                              setObserverTargetRef={setObserverTargetRef}
                            />
                          </div>
                        ) : (
                          <div className="particularCategoryNoResultFound">
                            <Box className="centerItems">
                              <p className="no-data-wrapper-text">NO RESULT FOUND</p>
                            </Box>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}

                {!isMobile && (
                  <div className="pcp-resizer" onMouseDown={startResizingCart}>
                    <div className="pcp-resizer-handle">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        aria-hidden="true"
                      >
                        <circle cx="9" cy="12" r="1"></circle>
                        <circle cx="9" cy="5" r="1"></circle>
                        <circle cx="9" cy="19" r="1"></circle>
                        <circle cx="15" cy="12" r="1"></circle>
                        <circle cx="15" cy="5" r="1"></circle>
                        <circle cx="15" cy="19" r="1"></circle>
                      </svg>
                    </div>
                  </div>
                )}
                {/* ─── Panel 3: Cart ─── */}
                <div
                  className="pcp-cart-panel"
                  style={{ width: isMobile ? "100%" : cartPanelWidthState }}
                >
                  <Cart
                    setSearchText={setSearchText}
                    handleOpen={handleOpen}
                    displayCgst={cgst}
                    displaySgst={sgst}
                    addOnProductList={addOnProductList}
                    selectedProductForCart={selectedProductForCart}
                    setCouponApplied={setCouponApplied}
                    complimentaryMode={complimentaryMode}
                    setComplimentaryMode={setComplimentaryMode}
                    onAddProductClick={() => setAddProductModal(true)}
                  />
                </div>
              </div>

              {addOnModalOpen && (
                <AddonModal
                  addOnModalOpen={addOnModalOpen}
                  setAddOnModalOpen={setAddOnModalOpen}
                  productDetails={selectedProductForCart}
                  onAddItem={increseItemQuantityTroughParticularCategory}
                  fetchVariantsFromAPI={false}
                />
              )}

              {comboModalOpen && (
                <ComboModal
                  open={comboModalOpen}
                  onClose={() => setComboModalOpen(false)}
                  product={comboModalProduct}
                  sellingPrice={comboModalPrice}
                  index={comboModalIndex}
                  onAddItem={increseItemQuantityTroughParticularCategory}
                  saleMode={saleMode}
                />
              )}

              <AddProductModal
                open={addProductModal}
                onClose={() => setAddProductModal(false)}
                onAdd={handleAddProduct}
                loading={addProductLoader}
              />
            </div>
          )}
        </Box>
      </Navbar>
    </>
  );
};
